import { call, put } from 'redux-saga/effects'
// @ts-ignore
import req from '@sportninja/common/api/request'
import actions from '../actions/account'
// @ts-ignore
import { generateSagas } from './utils'

export const api = {
  read: async (id: string) => await req(`/account/${id}`),
  fetchAccount: async (id: string) => await req(`/account/${id}`),
  updateAccount: async (id: string, data: any) =>
    await req(`/account/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),
  updateAccountContact: async (id: string, data: any) =>
    await req(`/account/${id}/contact`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),
  updateAccountAddress: async (id: string, data: any) =>
    await req(`/account/${id}/address`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),
  loadInvoices: async (id: string) =>
    await req(`/account/${id}/invoices`),
}

const accountSagas = [
  [
    actions.read,
    function* ({ id }: { id: string }) {
      const response = yield call(api.read, id)
      yield put(actions.read.success({ data: response.data }))
      return response
    },
  ],
  [
    actions.fetchAccount,
    function* ({ id }: { id: string }) {
      const response = yield call(api.fetchAccount, id)
      yield put(actions.fetchAccount.success({ data: response.data }))
      return response
    },
  ],
  [
    actions.updateAccount,
    function* ({ id, data }: { id: string; data: any }) {
      const response = yield call(api.updateAccount, id, data)
      yield put(actions.updateAccount.success({ data: response.data }))
      return response
    },
  ],
  [
    actions.updateAccountContact,
    function* ({ id, data }: { id: string; data: any }) {
      const response = yield call(api.updateAccountContact, id, data)
      yield put(actions.updateAccountContact.success({ data: response.data }))
      return response
    },
  ],
  [
    actions.updateAccountAddress,
    function* ({ id, data }: { id: string; data: any }) {
      const response = yield call(api.updateAccountAddress, id, data)
      yield put(actions.updateAccountAddress.success({ data: response.data }))
      return response
    },
  ],
  [
    actions.loadInvoices,
    function* ({ id }: { id: string }) {
      const response = yield call(api.loadInvoices, id)
      yield put(actions.loadInvoices.success({ data: response.data }))
      return response
    },
  ],
]

export default generateSagas([...accountSagas])
